import { isNetworkError } from '@if/core/utils';
import { nanoid } from 'nanoid';
let appInsights = null;
export function getSessionId() {
    let sessionId = sessionStorage.getItem('AppSessionId');
    if (!sessionId) {
        sessionId = nanoid();
        sessionStorage.setItem('AppSessionId', sessionId);
    }
    return sessionId;
}
export function setupTracking(ai, config) {
    appInsights = ai;
    appInsights.addTelemetryInitializer((envelope) => {
        const telemetryItem = envelope.data;
        telemetryItem.appSessionId = getSessionId();
        if (config?.appVersionKey && config?.appVersion) {
            telemetryItem[config.appVersionKey] = config.appVersion;
        }
    });
}
export function reportErrorToConsole(error) {
    console.error(error);
}
export function reportErrorToServer(error) {
    if (!isNetworkError(error)) {
        reportErrorToConsole(error);
        appInsights?.trackException({ error, severityLevel: 3 });
    }
}
export function reportTraceToServer(message) {
    appInsights?.trackTrace({ message });
}
